import { object, string, number } from "yup";

export const contactUsSchema = object().shape({
  name: string().required("Name is required"),
  
  
  instagram: string().matches(
    /^(?:(?:@)[a-zA-Z0-9]+)/,
    "Invalid Instagram handle"
  ),
 
  weddingDate: string()
    .required("Wedding date is required")
    .matches(
      /^(0?[1-9]|[12][0-9]|3[01])/ - /-\d\d$/,
      "Invalid date format"
    ),
    vanue: string().required("Please tell us your story"),

  photographer: string().required("Please tell us your photographer's name"),
 
  sthAboutUs: string().required("What made you interested in us?"),

});
